import {request, serviceUrl} from "@/utils/request";
import VueCookies from "vue-cookies";
import {Message} from "element-ui";
import {throttle} from "throttle-debounce";

// 引入cookie

export function checkToken() {
  if (!VueCookies.get('token')) {
    redirectLogin()
  }

  request({
    url: serviceUrl.ssoService + '/sso/check-token'
  }).then(res => {
    if (res && !res.code && res.code === -1) {
      refreshToken()
    }
  })
}

export const throttleRefreshToken = throttle(3000, () => {
  refreshToken()
})

export function refreshToken() {
  if (!window.g.autoRefreshToken) {
    Message.error("登录失效,请重新登录")
    return
  }
  request({
    method: 'post',
    url: serviceUrl.ssoService + '/sso/refresh-token',
    data: {
      clientId: window.g.clientId,
      secret: window.g.secret,
      refreshToken: VueCookies.get('refreshToken')
    }
  }).then(res => {
    if (res && res.code === 0) {
      // 先删除旧的 token
      VueCookies.remove('token', '/')
      VueCookies.remove('refreshToken', '/')
      
      // 设置新的 token
      VueCookies.set('token', res.data.accessToken, Number.parseInt(res.data.expiresIn), '/', window.g.domain)
      VueCookies.set('refreshToken', res.data.refreshToken, 60 * 60 * 15, '/', window.g.domain)
      
    } else {
      if (!window.g.autoRefreshToken) {
        Message.error("登录失效,请重新登录")
      } else {
        console.log('退出登录', new Date());
        // redirectLogin()
        return Promise.reject(new Error("刷新 token 失败"))
      }
    }
  })
}

export function logout() {
  VueCookies.remove('token', '/')
  return request({
    method: 'post',
    url: serviceUrl.ssoService + '/sso/logout'
  })
}

export function redirectLogin() {
  location.href = window.g.ssoUrl + 'sso/login?redirectUrl=' + window.location.protocol + "//" + window.location.host + '%23/login&clientId=' + window.g.clientId + '&secret=' + window.g.secret
}
